import React, { useEffect, useState } from "react";
import "../../../styles/desktop/dispositivo.css";

import fetchDispositivos from "../../../API/getDispositivos"

export default function Dispositivos() {
    const [dispositivos, setDispositivos] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const data = await fetchDispositivos();
            setDispositivos(data);
        };
        getData();
        const interval = setInterval(getData, 5000);
        return () => clearInterval(interval);
    }, []);
    

    return (
        <div className="dispositivosContainer">
            <div className="dispositivosCentral">
            {dispositivos.map((dispositivo, index) => (
                <div key={index} className="dispositivosModal">
                    <h3>{dispositivo.nome}</h3>
                    <h4>{dispositivo.ip}</h4>
                    <p>Tipo: {dispositivo.tipo}</p>
                    <p className={dispositivo.status ? "ativo" : "inativo"}>
                        Status: {dispositivo.status ? "Ativo" : "Inativo"}
                    </p>
                </div>
            ))}
            </div>
        </div>
    );
}